import { useSearch } from '@tanstack/react-router';
import { SupplyAppsPage } from '../../campaigns/supply/SupplyAppsPage';
import { SupplyDomainsPage } from '../../campaigns/supply/SupplyDomainsPage';
import { SupplyTabs } from '../../campaigns/supply/SupplyTabs';
import { SupplyTab } from '../../campaigns/supply/supplyRouteSearch';
import { TailoredSupplyTable } from '../../campaigns/supply/components/TailoredSupplyTable';
import { TailoredSupplyEditorPage } from '../../campaigns/supply/components/TailoredSupplyEditorPage';
import { AgencyEditorMode } from '../model';

/** The agency Supply section: apps, domains, or tailored supply with its editor. */
export function AgencySupplyContent() {
  const routeSearch = useSearch({ from: '/a/$agencyId_/campaigns/$section' });
  if (routeSearch.supplyTab === SupplyTab.Domains) return <SupplyDomainsPage />;
  if (routeSearch.supplyTab !== SupplyTab.Tailored) return <SupplyAppsPage />;
  if (routeSearch.editor === AgencyEditorMode.Create) return <TailoredSupplyEditorPage />;
  if (routeSearch.editor === AgencyEditorMode.Edit && routeSearch.id)
    return <TailoredSupplyEditorPage tailoredSupplyId={routeSearch.id} />;
  return (
    <>
      <SupplyTabs />
      <main className="page-gutter min-w-0 py-6">
        <TailoredSupplyTable />
      </main>
    </>
  );
}
